export const GenericContentSkeleton = () => (
  <div className='animate-pulse p-6 flex flex-col gap-6'>
    <div className='h-8 bg-tertiary rounded-sm w-1/3' />
    <div className='h-4 bg-tertiary rounded-sm w-2/3' />
    <div className='flex flex-col gap-4 mt-4'>
      <div className='h-24 bg-tertiary rounded-md w-full' />
      <div className='h-24 bg-tertiary rounded-md w-full' />
      <div className='h-24 bg-tertiary rounded-md w-full' />
    </div>
  </div>
);
